module.exports = __webpack_public_path__ + "static/media/btn_point_yright_pre.3065fe01.svg";